import {
  createFrontendModule,
  createTranslationResource,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { appTranslationRef } from './app.translation';

export const translationModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    TranslationBlueprint.make({
      params: {
        resource: createTranslationResource({
          ref: appTranslationRef,
          translations: {
            fr: () => import('./locales/fr'),
          },
        }),
      },
    }),
  ],
});
